import { useOutletContext } from 'react-router-dom'
import { PerfilPermissao } from '@/service/api'

export function usePermissoesOutletContext() {
    return useOutletContext<{ data: PerfilPermissao[] }>()
}
